import instance from 'api';
import { IPartnerUgoRating } from '../../interfaces';

export const savePartnerUgoRating = (partnerRatings: IPartnerUgoRating[]) => {
  return instance()
    .post(`/defectAct/v2/secondStepRatingUgo/listSave`, partnerRatings)
    .then((response) => response.data);
};
